/**
 * Section Templates Index
 *
 * Central registry for all section templates.
 * Templates are grouped by category for easy browsing and
 * can be accessed individually by ID.
 */

// Hero templates
import heroCentered from './hero/hero-centered';
import heroSplit from './hero/hero-split';
import heroWithImage from './hero/hero-with-image';
import heroDualButtons from './hero/hero-dual-buttons';

// Content templates
import logoBar from './content/logo-bar';
import statsSection from './content/stats-section';
import featureCard from './content/feature-card';

// Features templates
import features3col from './features/features-3col';
import features2col from './features/features-2col';
// import featureGrid from './features/feature-grid';
// import featureList from './features/feature-list';

// Testimonials templates
import testimonialSingle from './testimonials/testimonial-single';
import testimonial3col from './testimonials/testimonial-3col';

// CTA templates
import ctaSimple from './cta/cta-simple';
import ctaSplit from './cta/cta-split';
// import ctaBanner from './cta/cta-banner';

// Pricing templates
import pricing3col from './pricing/pricing-3col';

// Footer templates
import footerSimple from './footer/footer-simple';
import footerColumns from './footer/footer-columns';

/**
 * Templates organized by category
 * Each category contains an array of template objects
 */
export const templateCategories = {
  hero: [
    heroCentered,
    heroSplit,
    heroWithImage,
    heroDualButtons,
  ],
  content: [
    logoBar,
    statsSection,
    featureCard,
  ],
  features: [
    features3col,
    features2col,
    // featureGrid,
    // featureList,
  ],
  testimonials: [
    testimonialSingle,
    testimonial3col,
  ],
  cta: [
    ctaSimple,
    ctaSplit,
    // ctaBanner,
  ],
  pricing: [
    pricing3col,
  ],
  footer: [
    footerSimple,
    footerColumns,
  ],
};

/**
 * Flat array of all templates for searching and iteration
 */
export const allTemplates = [
  ...templateCategories.hero,
  ...templateCategories.content,
  ...templateCategories.features,
  ...templateCategories.testimonials,
  ...templateCategories.cta,
  ...templateCategories.pricing,
  ...templateCategories.footer,
];

/**
 * Find a template by its unique ID
 * @param {string} id - The template ID to search for
 * @returns {Object|undefined} The template object or undefined if not found
 */
export const getTemplateById = (id) => {
  return allTemplates.find((template) => template.id === id);
};

/**
 * Get all templates for a specific category
 * @param {string} category - The category name (hero, features, testimonials, cta, footer)
 * @returns {Array} Array of templates in the category, or empty array if category not found
 */
export const getTemplatesByCategory = (category) => {
  return templateCategories[category] || [];
};

/**
 * Get a list of all available category names
 * @returns {Array} Array of category name strings
 */
export const getCategoryNames = () => {
  return Object.keys(templateCategories);
};

/**
 * Get the total count of all templates
 * @returns {number} Total number of templates
 */
export const getTemplateCount = () => {
  return allTemplates.length;
};

const sectionTemplates = {
  templateCategories,
  allTemplates,
  getTemplateById,
  getTemplatesByCategory,
  getCategoryNames,
  getTemplateCount,
};

export default sectionTemplates;
